import { motion } from "framer-motion";

export default function PrivacyPolicy() {
  return (
    <div className="relative overflow-hidden bg-gradient-to-br from-blue-50 via-white to-blue-100 min-h-screen py-16 px-6">
      {/* Background Animation */}
      <motion.div
        className="absolute -top-20 -left-20 w-96 h-96 bg-blue-300/30 rounded-full blur-3xl"
        animate={{ x: [0, 50, -50, 0], y: [0, -40, 40, 0] }}
        transition={{ duration: 15, repeat: Infinity, ease: "easeInOut" }}
      />
      <motion.div
        className="absolute -bottom-20 -right-20 w-96 h-96 bg-orange-300/30 rounded-full blur-3xl"
        animate={{ x: [0, -50, 50, 0], y: [0, 40, -40, 0] }}
        transition={{ duration: 18, repeat: Infinity, ease: "easeInOut" }}
      />

      <div className="relative max-w-5xl mx-auto bg-white shadow-2xl rounded-2xl p-10">
        <motion.h1
          className="text-4xl font-bold text-blue-900 mb-6"
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          Privacy Policy
        </motion.h1>
        <p className="text-gray-600 mb-6">
          At <span className="font-semibold">Shree Engineering</span>, we are committed to safeguarding your privacy. 
          This policy outlines how we collect, use, and protect your information.
        </p>

        <div className="space-y-6 text-gray-700">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}
          >
            <h2 className="text-xl font-semibold text-blue-800 mb-2">1. Information We Collect</h2>
            <p>
              We may collect personal details such as your name, email, phone number, and company details 
              when you contact us, request information, or use our services.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}
          >
            <h2 className="text-xl font-semibold text-blue-800 mb-2">2. How We Use Your Information</h2>
            <ul className="list-disc pl-6 space-y-1">
              <li>To provide and improve our engineering services</li>
              <li>To respond to your inquiries</li>
              <li>To send important updates and offers</li>
              <li>To maintain compliance with legal obligations</li>
            </ul>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}
          >
            <h2 className="text-xl font-semibold text-blue-800 mb-2">3. Data Security</h2>
            <p>
              We implement strict security measures to protect your personal data from unauthorized 
              access, alteration, or disclosure.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}
          >
            <h2 className="text-xl font-semibold text-blue-800 mb-2">4. Contact Us</h2>
            <p>
              If you have any questions regarding our privacy policy, please email us at{" "}
              <span className="text-blue-600 font-medium">info@shree-eng.com</span>.
            </p>
          </motion.div>
        </div>
      </div>
    </div>
  );
}
